import type { FaireReviewEntity } from "../../entity_types/review";

// Real product review, pulled from Sweet Wink's live Faire product page for
// the Coquette Football Patch Sweatshirt (faire.com/product/p_vnf3c53k58),
// via the public, unauthenticated
// `GET /api/product-reviews/product/{product_token}` endpoint (the same one
// the PDP itself calls) — verbatim reviewer name/location/text/date, nothing
// paraphrased or invented.
export const review_sw8: FaireReviewEntity = {
  token: "review_sw8",
  type: "review",
  brandName: "Sweet Wink",
  brandToken: "b_gro99lye",
  productToken: "p_vnf3c53k58",
  productImageUrl:
    "https://cdn.faire.com/fastly/34a2322e7e2d51636ee7b829df9e53becd53e245dda767e6cf34474cf07481f8.jpeg",
  reviewerName: "Amy W.",
  reviewerLocation: "bay city, MI, United States",
  stars: 5,
  reviewText:
    "Customer service is beyond amazing! Super fast to replying! Products are so fun great quality and are flying of the racks for me!",
  reviewDate: "Sep 25, 2025",
  reviewType: "product",
  meta: {
    source: "api",
    importedAt: "2026-08-12T07:15:00.000Z",
    importedBy: "entity-db-cli",
  },
};
